import { useEffect } from "react";
import constants from "../utils/constants";

const { BACKEND_URL } = constants;

function ClickRedirect() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id") || "inconnu";
    console.log(encodeURIComponent(id));
    window.location.href = `${BACKEND_URL}/tracking/click?id=${encodeURIComponent(id)}`;
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: 60 }}>
      {/*<h2>{click_redirect.title[lang] || click_redirect.title.fr}</h2>
      <p>{click_redirect.message[lang] || click_redirect.message.fr}</p>*/}
    </div>
  );
}

export default ClickRedirect;
